import type { CSSProperties } from 'react';

/**
 * the internal storage key for the theme
 */
export const DEFAULT_STORAGE_KEY = `frame-io--ui-vapor-theme` as const;

/**
 * the media query checking for the client-preferred color scheme
 */
export const MEDIA_QUERY = `(prefers-color-scheme: dark)`;

/**
 * the acceptable values for the color scheme
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/color-scheme
 */
export const COLOR_SCHEMES: Array<
  Extract<CSSProperties['colorScheme'], `dark` | `light`>
> = [`light`, `dark`] as const;

export const SYSTEM_THEME_VALUE = `auto`;

export const DEFAULT_TOAST_MARGIN = `12px`;
